import { useTranslation } from "react-i18next";
import { Modal } from "@/shared/ui";
import { X } from "@/shared/ui/icons";
import { TermsContent } from "@/shared/layout";

export function TermsModal({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const { t } = useTranslation();
  return (
    <Modal
      id="terms-modal"
      open={open}
      onOpenChange={onOpenChange}
      title={t("home.signup.modalInfoTitleTerms")}
    >
      <header className="modal-header">
        <h2>{t("home.signup.modalInfoTitleTerms")}</h2>
        <button
          className="icon-button"
          aria-label={t("shell.actions.close")}
          onClick={() => onOpenChange(false)}
        >
          <X />
        </button>
      </header>
      <div className="modal-content">
        <TermsContent />
      </div>
      <footer className="modal-footer">
        <button className="btn" onClick={() => onOpenChange(false)}>
          {t("home.signup.modalInfoConfirm")}
        </button>
      </footer>
    </Modal>
  );
}
